<template>
  <footer
    class="section is-fixed-bottom has-background-white-bis"
    style="padding:20px 20px 60px 20px;"
  >
    <div class="content has-text-centered">
      <p>
        <strong>{{ $t('title.onlineInternalAudit') }}</strong> © 2020 Neta Denetim Tarafından
        Hazırlanmıştır
        <br />
        <span class="is-size-7">
          Developed & Designed by
          <strong>
            <a href="https://www.emrahyumuk.com/" target="_blank">Emrah Yumuk</a>
          </strong>
        </span>
      </p>
    </div>
  </footer>
</template>

<script>
export default {}
</script>
